import { useState } from "react";


const PromotionTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id); // Initialize with the first tab's ID
  
  const handleTabClick = (tabId) => {
    setActiveTab(tabId); // Change active tab when clicked
  };

  return (
    <div className="w-full ">
      {/* Tab Buttons */}
      <div className="flex space-x-1.5 px-5 pt-4 ">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`${
              activeTab === tab.id
                ? "bg-[#65758B] text-white shadow-lg"
                : "bg-[#E1E7EF] text-[#65758B]"
            } text-xs flex-1 py-2 rounded-lg font-semibold transition-all duration-300 hover:text-white focus:outline-none`}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="px-5 my-4 overflow-y-auto hide-scrollbar" style={{ height: 'calc(100vh - 150px)' }}>
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div key={tab.id}>
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default PromotionTabs;
